import React from 'react';
import Link from "next/link";
import styled from "styled-components";
import {LazyLoadImage} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Carousel, {CarouselItem} from '@molecules/swiper/carousel';
import Skeleton from 'react-loading-skeleton';
import {getAreaCoverThumb} from "@models/area";
import {getDistrictImage} from "@models/district";
import {isEmpty, str_replace} from "@helpers/helpers";
import RadiusGenerate from "@helpers/radius.generate";
import {useWindowSize} from "@helpers/windows.size";
import Icon from "@atoms/icon";
import ConvertPixelToRem from "@helpers/convert.rem";
import ChevronLeftIcon from '@icons/chevron-left.svg';

function LandingAreasSlider({items = [], breakpoints, href, hrefAs, urlParams = null, appendAs, className, pagination = false, captionClassName}) {
    const windowSize = useWindowSize();

    return (
        <Container>

            <Carousel breakpoints={breakpoints} pagination={pagination} navigation_show={(items.length > 4)}>
                {
                    (items.length) ?
                        items.map((item, key) => {
                            let captionUrl = str_replace(' ', '-', item.caption);
                            const urlHrefAs = (!isEmpty(item.url) ? item.url : (!isEmpty(appendAs) ? ('/املاک-' + captionUrl + appendAs) : (hrefAs + captionUrl))) + (!isEmpty(urlParams) ? urlParams : '');

                            return (
                                <CarouselItem key={key}>
                                    <Card>
                                        <Link href={(!isEmpty(href) ? href : "/properties")} as={urlHrefAs}>
                                            <a>
                                                <ImageCard className="slider-image">
                                                    <LazyLoadImage
                                                        src={(!isEmpty(item.item_id) && item.item_id > 0) ? getAreaCoverThumb(item.item_id) : getDistrictImage(item.label)}
                                                        effect="blur"
                                                        height="100%"
                                                        width="100%"
                                                        alt={item.caption}/>
                                                </ImageCard>

                                                <div className="d-flex align-items-center justify-content-between areas-slider-title">
                                                    <span className={"h4-normal " + (captionClassName ?? '')}>{item.caption}</span>
                                                    <Icon><ChevronLeftIcon title=""/></Icon>
                                                </div>
                                            </a>
                                        </Link>
                                    </Card>
                                </CarouselItem>
                            )
                        })
                        :
                        [...Array(6)].map((item, key) =>
                            <CarouselItem key={key}>
                                <Card>
                                    <Skeleton width="100%" height={(windowSize > 991 ? 108 : 90)} className="position-relative tehran-region-skeleton" style={{top: '-4px', borderRadius: '16px 16px 0 0'}}/>
                                    <div className="py-8 px-16 position-relative" style={{top: '-3px'}}>
                                        <Skeleton width="80%"/>
                                    </div>
                                </Card>
                            </CarouselItem>
                        )
                }
            </Carousel>
        </Container>
    )
}

export default React.memo(LandingAreasSlider);

// styles

const Container = styled.div`
 
`;

const ImageCard = styled.div`
    width: 100%;
    height: 108px;
    border-radius: 16px 16px 0 0;
    background-color: ${props => props.theme.gray100};
    
    img {
        background-color: ${props => props.theme.gray100};
        min-height: 100%;
        height: 100%;
        max-height: 100%;
        min-width: 100%;
        max-width: 100%;
        border-radius: 16px 16px 0 0;
        width: 100%;
        overflow: hidden;
        -o-object-fit: cover;
        object-fit: cover;
        -o-object-position: 50% 50%;
        object-position: 50% 50%;
    }
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        height: 90px;
    }
`;

const Card = styled.div`
    box-shadow: 0 3px 16px 0 rgba(0, 0, 0, 0.12);
    background-color: #ffffff;
    ${RadiusGenerate('20px')};
    
    .icons {
        width: 6px;
        display: none;
    }
    
    &:hover {
        .icons {
            display: flex;
        }
    }
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        .h3 {
            font-size: ${ConvertPixelToRem(15)};
        }
        
        .icons {
            display: flex;
        }
    }
    
    .areas-slider-title {
		padding: 10px 16px;
    }
`;


